import { useEffect, useState } from "react";

function App() {
  
  const [loading, setLoading] = useState(false);
  const [newquote, setNewquote] = useState(null);

    const fetchQuote = async () => {
      try {
        setLoading(true);
        const url = 'https://api.api-ninjas.com/v1/quotes';
        const XAPIKEY = 'DGokzYQ7e7U8/MpiSs/rnQ==S34efFOSErOhrVtH';
        const response = await fetch(url, {
          method:'GET',
          headers: {
            'X-Api-Key': XAPIKEY,
          },
        });
        
        const [data] = await response.json();
        setNewquote(data);

      } catch (error) {
        console.log('Error fetching code', error);
        setLoading(false);
      }
    }

    useEffect(()=>{
      fetchQuote();
    },[])

  return (
    <main className="h-screen flex items-center justify-center bg-zinc-200">
      <QuoteBody fetchQuote={fetchQuote} newquote={newquote}/>
    </main>
  );
}

export default App;


const QuoteBody = ({fetchQuote, newquote}) => {
  return(
    <div className="flex flex-col gap-4 justify-center items-center px-8 md:px-24">

      {
        newquote ? (
          <>
            <h2 className="font-comforter text-2xl md:text-5xl text-center text-gray-700">" {newquote.quote} "</h2>
            <h3 className="font-comforter  text-lg md:text-xl text-center text-gray-700">- {newquote.author}</h3>
          </>
        ) : 
        (   <h2 className="font-comforter text-xl text-gray-500"> Quote is Loading...</h2>)
      }
      
      
      <button className="bg-gray-800 text-white rounded-full px-6 py-3 hover:bg-gray-700" onClick={fetchQuote}>Get New Quote</button>

    </div>
  );
};
